import React, { useMemo } from 'react';
import { Card } from '@totalsoft/rocket-ui';
import ListAlt from '@mui/icons-material/ListAlt';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { DOCUMENT_SYNC_STATES_QUERY } from '../queries';
import ListBrowser from '@ts-private/list-browser';
import { documentSyncStatesStore } from './store';
import ItemsComponent from './ItemsComponent';
import { reactiveStore, useReactiveStore } from '@ts-private/reactive-store';

export const filterDocumentSyncStatesStore = reactiveStore((data, _pager, _filters) => [...data])

const BrowserComponent = () => {
  const [filterDocumentSyncStates] = useReactiveStore(filterDocumentSyncStatesStore);

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: DOCUMENT_SYNC_STATES_QUERY,
        name: 'documentSyncStates'
      },
      clientFilter: filterDocumentSyncStates
    }),
    [filterDocumentSyncStates]
  );

  return (
    <Card icon={ListAlt}>
      <ListBrowser store={documentSyncStatesStore} ItemsComponent={ItemsComponent} />
      <ExportModalComponent store={documentSyncStatesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={documentSyncStatesStore} options={fetchingOptions} />
    </Card>
  );
};

export default BrowserComponent;
